import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import MediaQuery from '../common/media_query';
import OpenerImage from '../common/opener_image';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import { isHomepageRefresh } from '../../utils/homepage_refresh/homepage';
import { MODULE_TYPE_HP_REFRESH_SHOPS_CATEGORY } from '../module/mobile_content_module';

export default class CategoryCard extends PureComponent {
  handleClick = () => {
    sendAnalyticsEvent(
      '"R29 Shopping Collection" Module',
      'Click',
      this.props.url
    );

    sendDataLayerEvent(
      'Click',
      {
        module_name: 'Shopping',
        cta_text: this.props.name,
        destination_url: this.props.url,
        position: this.props.indexWithinModule - 1,
        linkUID: this.props.id,
        linkType: 'collection',
        linkTitle: this.props.name,
        linkHeadline: this.props.name,
        itemName: this.props.name,
      }
    );
  }

  render() {
    const { name, tagline, url, opener_images, rowType, moduleType, isLastInRow } = this.props;
    const { location, edition_data } = this.context;
    let shoppingIcon;

    if (isHomepageRefresh(location, edition_data, true)
      && moduleType === MODULE_TYPE_HP_REFRESH_SHOPS_CATEGORY
    ) {
      shoppingIcon = (
        <MediaQuery breakpoint="mobile">
          <span className="shopping-icon" />
        </MediaQuery>
      );
    }

    return (
      <div className="category-card-wrapper">
        <Link to={url} onClick={this.handleClick} className="category card">
          <OpenerImage
            rowType={rowType}
            opener_images={opener_images}
            isLastInRow={isLastInRow}
          />
          {shoppingIcon}
          <div className="category-content">
            <div className="tagline">
              {tagline ||
                <RosettaFormattedMessage parentFilename={__filename}
                  id="tagline"
                  description="Tagline that appears on shopping category cards"
                  defaultMessage="Shop the Collection"
                />
              }
            </div>
            <span className="name">{name}</span>
          </div>
        </Link>
      </div>
    );
  }
}

CategoryCard.propTypes = {
  name: PropTypes.string.isRequired,
  tagline: PropTypes.string,
  url: PropTypes.string.isRequired,
  opener_images: PropTypes.array.isRequired,
  indexWithinModule: PropTypes.number.isRequired,
  rowType: PropTypes.string.isRequired,
  moduleType: PropTypes.string,
  isLastInRow: PropTypes.bool,
  id: PropTypes.number.isRequired
};

CategoryCard.contextTypes = {
  location: PropTypes.object,
  edition_data: PropTypes.object
};
